// extracted by mini-css-extract-plugin
export default {"term-finder__input":"UZOXCa"};